import { Col, Row, Typography } from 'antd';
import type { ReactNode } from 'react';

const { Text } = Typography;

export type SlaExpandedDetailItem = {
  key: string;
  label: string;
  value: ReactNode;
};

type Props = {
  items: SlaExpandedDetailItem[];
};

export function SlaExpandedDetailGrid({ items }: Props) {
  return (
    <Row gutter={[16, 12]}>
      {items.map((item) => (
        <Col key={item.key} xs={24} sm={12} md={8} lg={6}>
          <Text type="secondary" className="sla-expanded-detail-label">
            {item.label}
          </Text>
          <div className="sla-expanded-detail-value">{item.value}</div>
        </Col>
      ))}
    </Row>
  );
}
